const { decode } = require("jsonwebtoken");

const loggedUser = () => {
  if (localStorage.USER) {
    console.log(JSON.parse(localStorage.USER).account);
    return JSON.parse(localStorage.USER).account;
  } else {
    return undefined;
  }
}



const loggedToken = () => {
  if (localStorage.USER) return decode(JSON.parse(localStorage.USER).token);
  else return undefined;
}

const decodeToken = (token) => {
  return decode(token);
}

const loggedProperty = (property) => {
  if (loggedToken() && loggedToken()[property]) return loggedToken()[property]
  else return undefined
}

const loggedAccountType = () => {
  if (loggedToken() && loggedToken().account_type_id) return loggedToken().account_type_id
  else return undefined
}

const loggedPermissions = () => {
  if (localStorage.PERMISSIONS) {
    const permissions = JSON.parse(localStorage.PERMISSIONS);
    return decode(permissions.permissions).rows;
  } else return undefined
}

export { loggedAccountType, loggedToken, loggedUser, decodeToken, loggedPermissions, loggedProperty }
